<section class="flex flex-col max-w-full p-2 mt-8">
  <h1
    class="flex flex-row items-center justify-center p-2 text-center bg-gray-800 border-4 border-gray-700 border-solid"
  >
    <img class="w-8 h-8 mr-2 fill-current" src="/favicon.ico" alt="Logo" />
    <span>STC2-DB - Login</span>
  </h1>

  <div
    *ngIf="errorMessage"
    class="p-2 mx-auto mt-4 text-center text-red-500 bg-gray-800 border-2 border-red-500 border-solid rounded-md max-w-fit"
  >
    {{ errorMessage }}
  </div>

  <form
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
    class="grid grid-cols-2 gap-1 p-2 mx-auto mt-8 border-8 border-gray-700 border-solid rounded-lg"
  >
    <label
      for="login"
      class="w-32 px-2 bg-gray-800 border-2 border-gray-800 border-solid"
    >
      Benutzername
    </label>
    <input
      class="w-32 px-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
      type="text"
      id="login"
      formControlName="login"
    />
    <label
      for="password"
      class="w-32 px-2 bg-gray-800 border border-gray-800 border-solid"
    >
      Passwort
    </label>
    <input
      class="w-32 px-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
      id="password"
      type="password"
      formControlName="password"
    />
    <button
      type="submit"
      [disabled]="!loginForm.valid"
      class="w-32 py-1 mt-1 bg-gray-800 border border-gray-500 border-solid rounded-md hover:border-orange-300 hover:text-orange-300"
    >
      Anmelden
    </button>
    <button
      type="reset"
      class="w-32 py-1 mt-1 bg-gray-800 border border-gray-500 border-solid rounded-md hover:border-orange-300 hover:text-orange-300"
    >
      Abbrechen
    </button>
  </form>
</section>
